import Icon1 from "@assets/icons/Icon";
import { useState } from "react";
import { colors } from "sexy";

type SideBarButtonProps = {
  label: string;
  onClick?: () => void;
  className?: string;
  name: string;
  highlighted?: boolean;
};

export default function SideBarButton(props: SideBarButtonProps) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => props.onClick && props.onClick()}
      className="flex flex-row gap-4 hover:bg-neutral-50  hover:ring-neutral-200  rounded-lg items-center  cursor-pointer w-full px-2 py-1.5 "
      style={{
        color: hovered || props.highlighted ? colors.black : colors.neutral_400,
      }}
    >
      <Icon1
        name={props.name}
        size={22}
        color={hovered || props.highlighted ? colors.black : colors.neutral_400}
      />
      <div className="text-h2 font-medium ">{props.label}</div>
    </div>
  );
}
